module.exports = __webpack_public_path__ + "media/application/images/icons/innovations/level-high-9dd5c115e109bec433c2e1c78431d235.svg";